// extracted by mini-css-extract-plugin
export default {"text":"qk6zO78CBXgBeSxM"};